export default () => {
    if (process.browser && window.hasOwnProperty('crypto')) {
        const GenerateRSAWorker = require('../workers/generate-rsa.worker');
        window.__generateRSAWorker__ = new GenerateRSAWorker();
    }
};
